import React from 'react';
import './WelcomeModal.css'; // Предполагается, что стили будут в этом файле

const WelcomeModal = ({ onClose }) => {
  return (
    <div className="welcome-modal">
      <div className="welcome-modal-content">
        <h2>Добро пожаловать в ЦРМ систему!</h2>
        <p>Мы рады видеть вас. Ознакомьтесь с возможностями системы и начните работу.</p>
        <button onClick={onClose}>Закрыть</button>
      </div>
    </div>
  );
};

export default WelcomeModal;
